import {ReactComponent as UploadIcon} from "assets/image/Layout/ObjectPanel/ic_upload.svg";
import styles from "./index.module.scss";

export default function UploadHelper() {
  const openTermPage = () => {
    window.open("https://create.redbrick.land/support/terms");
  };

  return (
    <div className={styles.container}>
      <div className={styles.upload}>
        <UploadIcon />
        <p className={styles.title}>끌어와서 파일 업로드</p>
        <p className={styles.desc}>
          {`gltf, glb, png, jpg, jpeg, mov, mp4, mpeg, mp3, wav\n형식의 파일을 한 번에\n여러 개 업로드할 수 있습니다.`}
        </p>
      </div>
      <p className={styles.terms}>
        {`고객님이 업로드하는 콘텐츠가\n`}
        레드브릭의 <span onClick={openTermPage}>이용약관</span>을 준수하며,
        {`\n제 3자의 어떠한 권리도\n침해하고 있지 않음을 확인합니다.`}
      </p>
    </div>
  );
}
